import React, { useEffect, useState } from "react";

import { getAllFields, getFieldShapeAdmin } from "services";

import { useCancelAsyncOnUnmount } from "utils";

import { AdminHead, Button, Col, ErrorBoundary, MainPage, Option, Row, Select } from "components";

import { SplitFieldDrawer } from "pages/app/fields/components/SplitFieldDrawer";

export const FieldSplitting = () => {
  const [geometry, setGeometry] = useState(null);
  const [loading, setLoading] = useState(false);
  const [fields, setFields] = useState([]);
  const [field, setField] = useState(null);
  const [showDrawer, setShowDrawer] = useState(false);
  const signal = useCancelAsyncOnUnmount()();

  const loadAllFields = () => {
    getAllFields({
      signal,
      page: 0,
    })
      .then((res) => {
        setFields(res.fields);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    loadAllFields();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (field) {
      getFieldShapeAdmin({ fieldId: field.id }).then((res) => setGeometry(res.fieldShape));
    }
  }, [field]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <MainPage loading={loading} pageName="admin">
      <AdminHead headline="Field splitting" description="Select a field, open the drawer and split a field" />
      <div className="content">
        <Row gutter={[{ xs: 8, sm: 8, md: 16 }, 32]} className="margin-top-200">
          <Col>
            <Select label="Select field" optionFilterProp="children" onChange={(id) => setField(fields.find((field) => field.id === id))}>
              {fields.map((field, i) => (
                <Option label={field.name} value={field.id} key={i} text={field.name}>
                  {field.name}
                </Option>
              ))}
            </Select>
            {field && (
              <Button type="primary" onClick={() => setShowDrawer(true)}>
                Open the drawer
              </Button>
            )}
            {field && geometry && showDrawer && (
              <ErrorBoundary>
                <SplitFieldDrawer
                  field={field}
                  geometry={geometry}
                  onClose={() => setShowDrawer(false)}
                  visible={showDrawer}
                  enforceSubmissionRestriction={false}
                />
              </ErrorBoundary>
            )}
          </Col>
        </Row>
      </div>
    </MainPage>
  );
};
